<template>
    <v-card>
        <v-list rounded>
        <v-subheader>USER MENU</v-subheader>
        <v-list-item-group
            v-model="selectedItem"
            color="accent"
        >
            <v-list-item v-if="userType === 'Teacher'">
                <v-list-item-icon>
                    <span class="icon-badge">
                        <v-icon size="20">mdi-typewriter</v-icon>
                    </span>
                </v-list-item-icon>
                <v-list-item-content>
                    <router-link to="scores" class="nav-link">
                        <v-list-item-title>Record Scores</v-list-item-title>
                    </router-link>
                </v-list-item-content>
            </v-list-item>
            <v-list-item>
                <v-list-item-icon>
                    <span class="icon-badge">
                        <v-icon size="20">mdi-printer</v-icon>
                    </span>
                </v-list-item-icon>
                <v-list-item-content>
                    <router-link to="sheets" class="nav-link">
                        <v-list-item-title>Print Result Sheets</v-list-item-title>
                    </router-link>
                </v-list-item-content>
            </v-list-item>
            <v-list-item @click="signout">
            <v-list-item-icon>
                <span class="icon-badge icon-badge--danger">
                    <v-icon size="20">mdi-minus-circle-outline</v-icon>
                </span>
            </v-list-item-icon>
            <v-list-item-content>
                <v-list-item-title>Sign Out</v-list-item-title>
            </v-list-item-content>
            </v-list-item>
        </v-list-item-group>
        </v-list>
    </v-card>
</template>

<script>
  export default {
    name: 'TokenUserMenuCard',
    data: () => ({
        selectedItem: null,
        userType:sessionStorage.getItem('utpc') ?? null,
    }),
    methods: {
        signout () {
            sessionStorage.removeItem('authToken')
            sessionStorage.removeItem('accessToken')
            sessionStorage.removeItem('utpc')
            localStorage.removeItem('school')
            sessionStorage.removeItem('loggedUser')
            this.$store.commit("isLoggedIn", false);
            this.$store.commit("isTokenAccess", false);
            this.$router.push({name: 'MultiAccessLogin'})
        }
    }
  }
</script>

<style scoped>
.v-card{
    background: transparent !important;
    box-shadow: none !important;
}
.v-subheader{
    color: rgba(255, 255, 255, 0.45) !important;
    letter-spacing: 1.5px;
    font-weight: 700;
}
.icon-badge{
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 34px;
    height: 34px;
    border-radius: 10px;
    flex-shrink: 0;
    background: rgba(255, 255, 255, 0.08);
    color: rgba(255, 255, 255, 0.75);
}
.icon-badge--danger{
    background: rgba(230, 74, 25, 0.18);
    color: #FF8A65;
}
.nav-link{
    text-decoration: none;
    color: rgba(255, 255, 255, 0.85) !important;
    display: block;
    width: 100%;
}
.router-link-active{
    color: #FB8C00 !important;
    font-weight: 700;
}
</style>
